export default "__VITE_ASSET__DXbLJp0w__"